var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "noListStyle" }, [
    _c("img", { attrs: { src: _vm.noListUrl, alt: "" } }),
    _vm._v(" "),
    _c("p", [_vm._v("暂无数据！")])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }